import React from 'react'

function Call() {
  return (
    <>
          <div className="call-to-action">
      <div className="container w-container">
        <div className="call-to-action-wrapper">
          <div className="call-to-action-title-block">
            <div className="section-title-block">
              <div className="section-intro-block style-two">
                Simple Easy Quick Steps
              </div>
              <h2 className="section-title mb-0px">
                If Need any help Contact to Us?
              </h2>
            </div>
          </div>
          <div className="call-to-action-info-block">
            <div className="call-to-action-info-block-inner">
              <div className="call-to-action-single-info">
                <div className="call-to-action-info-text">Contact us</div>
                <a href="mailto:amukimproduction@gmail.com" className="call-to-action-info-link">amukimproduction@gmail.com</a>
              </div>
              <div className="call-to-action-single-info">
                <div className="call-to-action-info-text">Call us 24/7</div>
                <a href="tel:+918906369948" className="call-to-action-info-link">+91 8906369948</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    </>
  )
}

export default Call